import { ResultOf, VariablesOf } from '@graphql-typed-document-node/core';
import { useMutation } from '@tanstack/react-query';

import { useTicketsClient } from 'services/api';
import { TransferAcceptDocument } from 'types/api/tickets.types';

import { AppSyncTicketsGraphQLError } from './types';

export const useTransferAccept = () => {
  const ticketsClient = useTicketsClient();

  const { mutate, isPending, isPaused } = useMutation<
    ResultOf<typeof TransferAcceptDocument>,
    AppSyncTicketsGraphQLError,
    VariablesOf<typeof TransferAcceptDocument>['input']
  >({
    mutationFn: ({ transferId, version }) =>
      ticketsClient.request(TransferAcceptDocument, {
        input: { transferId, version },
      }),
    retry: false,
  });

  return {
    acceptTransfer: mutate,
    isLoading: isPending && !isPaused,
  };
};
